import { Button } from "../../ui/button";
import { Dialog } from "../../ui/dialog";
import { CustomerList } from "./CustomerList";

// "Switch customer": a dialog with the shared customer list (`CustomerList`: a search field, the customers that the SERVER allows this staff
// member to open, and "Show more").

export function CustomerPicker({
  onPick,
  onClose,
}: Readonly<{ onPick: (customerId: string) => void; onClose: () => void }>) {
  return (
    <Dialog
      title="Switch customer"
      description="Choose a customer to look at. You see only the customers you may open."
      onClose={onClose}
    >
      <CustomerList onPick={onPick} size="dialog" idPrefix="analytics-picker" />
      <div className="flex justify-end">
        <Button type="button" variant="outline" onClick={onClose}>
          Close
        </Button>
      </div>
    </Dialog>
  );
}
